var _rect, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllEmptyAccessSharingInviteSent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ill_empty_access_sharing_invite_sent",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 120,
    height: 120,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Illustration",
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#f7f7f7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.738,44.478H13.082C5.233,44.478,0,40.553,0,31.4V13.082C0,3.924,5.233,0,13.082,0H39.245c7.849,0,13.082,3.924,13.082,13.082V24.526",
    transform: "translate(33.837 37.761)",
    fill: "none",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M26.163,0,17.974,6.541a8.283,8.283,0,0,1-9.811,0L0,0",
    transform: "translate(46.918 52.151)",
    fill: "none",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364",
    transform: "translate(74 68)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(13.697 6.301) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_nav_up",
    d: "M7.167,0H0",
    transform: "translate(0.229 3.699)",
    fill: "none",
    stroke: "#f0f0f0",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M3.577,7.4,0,3.7,3.577,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#f0f0f0",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllEmptyAccessSharingInviteSent);
export default __webpack_public_path__ + "static/media/ill_empty_access_sharing_invite_sent.b8378e169d3d50f760e751f7b9c0fbef.svg";
export { ForwardRef as ReactComponent };